import { contextMixin, registry } from "@/context/context";
import TokenErrorAlertUtil from "@/utils/alerts/TokenErrorAlertUtil";
import CreateMediaWarningUtil from "@/utils/alerts/CreateMediaWarningUtil";
import CreateMediaErrorUtil from "@/utils/alerts/CreateMediaErrorUtil";
import CreateMediaSuccessUtil from "@/utils/alerts/CreateMediaSuccessUtil";
import CreateEventSuccessUtil from "@/utils/alerts/CreateEventSuccessUtil";
import CreateEventErrorUtil from "@/utils/alerts/CreateEventErrorUtil";

registry(TokenErrorAlertUtil, 'alertTokenError');
registry(CreateMediaWarningUtil, 'createMediaWarning');
registry(CreateMediaErrorUtil, 'createMediaError');
registry(CreateMediaSuccessUtil, 'createMediaSuccess');
registry(CreateEventSuccessUtil, 'createEventSuccess');
registry(CreateEventErrorUtil, 'createEventError');

export default contextMixin;
